module.exports = __webpack_public_path__ + "img/7_149.60125bc5.png";